module.exports = __webpack_public_path__ + "img/lower-back.51b9f92c.jpg";